import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

//OBTIENE LOS INGRESOS MATERIALES ENCABEZADO POR FECHA
export const ObtenerIngresosMaterialesEnc = async (data) => {
  return await PrivateInterceptor("Suministros/RequisasMaterial", "POST", data);
};

export const ObtenerRequisaMateriaPrimaEnc = async (data) => {
  return await PrivateInterceptor("Suministros/RequisasMaterial/MateriaPrima", "POST", data);
};

//OBTIENE LOS INGRESOS MATERIALES DETALLES POR FECHA
export const ObtenerIngresosMaterialesdET = async (data) => {
  return await PrivateInterceptor(
    "Suministros/RequisasMaterial/listadoDetalles",
    "POST",
    data
  );
};

//OBTIENE LOS INGRESOS MATERIALES DETALLES POR FECHA
export const ObtenerRequisasAgrupadas = async (data) => {
  return await PrivateInterceptor("Suministros/RequisasMaterial/listadoDetalles_Salidas", "POST", data);
};

//OBTIENE EL SIGUIENTE NUMERO DE INGRESO
export const ObtenerSiguienteNoIngresoMateriale = () => {
  const respuesta = PrivateInterceptor(
    "Suministros/RequisasMaterial/ObtenerNumeroRequisaMaterial",
    "GET"
  );
  return respuesta;
};

//OBTIENE EL SIGUIENTE NUMERO DE INGRESO MP
export const ObtenerSiguienteNoIngresoMP = () => {
  const respuesta = PrivateInterceptor(
    "Suministros/RequisasMaterial/ObtenerNumeroRequisaMP",
    "GET"
  );
  return respuesta;
};


//OBTIENE DETALLE REQUISA POR REQUISA
export const ObtenerDetalleRequisa = async (Requisa) => {
  const result = await PrivateInterceptor(
    `Suministros/RequisasMaterial/ObtenerDetalleRequisa`,
    "POST",
    { Requisa }
  );
  return result;
};

//OBTIENE DETALLE REQUISA POR REQUISA
export const ObtenerDetalleRequisaReporte = async (Requisa) => {
  const result = await PrivateInterceptor( `Suministros/RequisasMaterial/listadoRequisasPorRequisa`,  "POST", { Requisa } );
  return result;
};

//OBTIENE DETALLE REQUISA POR REQUISA CRUD 
export const ObtenerDetalleRequisaCRUD = async (Requisa) => {
  const result = await PrivateInterceptor(
    `Suministros/RequisasMaterial/ObtenerDetalleRequisaCRUD`,
    "POST",
    { Requisa }
  );
  return result;
};

//OBTIENE DETALLE REQUISA POR REQUISA CRUD 
export const ObtenerDetalleRequisaCRUD1 = async (Requisa) => {
  const result = await PrivateInterceptor(
    `Suministros/RequisasMaterial/ObtenerDetalleRequisaCRUD1`,
    "POST",
    { Requisa }
  );
  return result;
};


//OBTIENE DETALLE REQUISA POR REQUISA
export const ObtenerDetalleRequisaPorId = async (IdRequisaDet) => {
  const result = await PrivateInterceptor(
    `Suministros/RequisasMaterial/ObtenerDetalleRequisaPorId`,
    "POST",
    { IdRequisaDet }
  );
  return result;
};

//OBTIENE DETALLE REQUISA POR REQUISA
export const ObtenerEncabezadoRequisa = async (Requisa) => {
  const result = await PrivateInterceptor(
    `Suministros/RequisasMaterial/ObtenerEncabezadoRequisa`,
    "POST",
    { Requisa }
  );
  return result;
};

export const ObtenerEncabezadoRequisaMP = async (Requisa) => {
  const result = await PrivateInterceptor(
    `Suministros/RequisasMaterial/ObtenerEncabezadoRequisaMP`,
    "POST",
    { Requisa }
  );
  return result;
};

//OBTIENE DETALLE REQUISA POR REQUISA
export const ObtenerEncabezadoRequisaSinE = async (Requisa) => {
  const result = await PrivateInterceptor(
    `Suministros/RequisasMaterial/ObtenerEncabezadoRequisasSinEliminar`,
    "POST",
    { Requisa }
  );
  return result;
};


// ELIMINAR ITEM DE INGRESO DETALLE
export const EliminarItemIngreso = async (data) => {
  const respuesta = PrivateInterceptor("Suministros/RequisasMaterial/EliminarItemIngreso", "POST",{Detalle: data});
  return respuesta;
};

// ELIMINAR ITEM DE INGRESO REQUISA (Encabezado y Detalles)
export const EliminarIngresoRequisa = async (data) => {
  const respuesta = await PrivateInterceptor("Suministros/RequisasMaterial/EliminarIngresoRequisa", "POST", { Encabezado: data });
  return respuesta;
};


// ELIMINAR ITEM DE INGRESO
export const GuardarRequisaMaterial = async (data, data2) => {
  const respuesta = PrivateInterceptor("Suministros/RequisasMaterial/GuardarRequisaMaterial", "POST",{Encabezado: data, Detalle: data2});
  return respuesta;
};


// ELIMINAR ITEM DE INGRESO
export const EditarRequisaMaterial = async (data, data2) => {
  const respuesta = PrivateInterceptor("Suministros/RequisasMaterial/EditarRequisaMaterial", "POST",{Encabezado: data, Detalle: data2});
  return respuesta;
};


//DETALLES DE REQUISA FILTRADORS POR FECHA
export const getRequisasMaterialDetalle = async (data) => {
  return await PrivateInterceptor('Suministros/RequisasMaterial/listadoRequisasMPorFecha', 'POST', data);
}

export const getRequisasMaterialPendienteRevision = async (data) => {
  return await PrivateInterceptor('Suministros/RequisasMaterial/listadoRequisasMPendienteRevision', 'POST', data);
}


//DETALLES DE REQUISA FILTRADORS POR FECHA
export const getRequisasMaterialPendRevision = async (data) => {
  return await PrivateInterceptor('Suministros/RequisasMaterial/listadoRequisasMPPendienteRevision', 'POST', data);
}


//DETALLES DE REQUISA FILTRADORS POR FECHA
export const getRequisasMateriaPrima = async (data) => {
  return await PrivateInterceptor('Suministros/RequisasMaterial/listadoRequisasMPPorFecha', 'POST', data);
}


//OBTIENE LOS INGRESOS MATERIALES ENCABEZADO POR FECHA
export const ObtenerRequisasMaterialesEnc = async (data) => {
  return await PrivateInterceptor("Suministros/RequisasMaterial/EncabezadoRequisa", "GET");
};

//OBTIENE LOS INGRESOS MATERIALES ENCABEZADO POR FECHA
export const ObtenerRequisasMaterialesDet = async (data) => {
  return await PrivateInterceptor("Suministros/RequisasMaterial/ListadoDetalleRequisa", "GET");
};


export const ObtenerRequisasMaterialesDetSalidas = async () => {
  const a = await PrivateInterceptor("Suministros/RequisasMaterial/ListadoDetalleRequisaSalidas", "GET");
  return a
};

// GET DETALLES DE UNA REQUISA POR ASIGNACION
export const getRequisaMPorAsignacion = async (IdOrdenDeTrabajoEnc) => {
  const result = await PrivateInterceptor(`Suministros/RequisasMaterial/getRequisaPorAsignacion`, 'POST', { IdOrdenDeTrabajoEnc })
  return result;
}
